import { render } from "./unghost.vue?vue&type=template&id=1536631f&lang=pug"
import script from "./unghost.vue?vue&type=script&lang=js"
export * from "./unghost.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__